import React from 'react';

import type * as api from '@gitbook/api-client';
import type * as analytics from '@gitbook/app-analytics/client';
import { isDocumentEmpty } from '@gitbook/doc-core';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Heading,
    Link,
    RevealableToolbar,
    RevealableToolbarItem,
    RevealableToolbarRoot,
} from '@gitbook/spine-react';

import {
    BasicEditor,
    ChangeRequestDescriptionField,
    type ChangeRequestDescriptionFieldRef,
    useChangeRequestDescriptionValue,
} from '../../../Components';

export function ChangeRequestDescription(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
}) {
    const { changeRequest } = props;

    const initialDescription = useChangeRequestDescriptionValue(changeRequest);
    const [editing, setEditing] = React.useState(false);
    const editorRef = React.useRef<ChangeRequestDescriptionFieldRef>(null);

    React.useEffect(() => {
        if (editing) {
            editorRef.current?.focus();
        }
    }, [editing]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <RevealableToolbarRoot>
                    <Heading level={2} className="text-muted text-ui-heading-group">
                        Description
                    </Heading>
                    {editing ? null : (
                        <RevealableToolbar>
                            <RevealableToolbarItem>
                                <Button
                                    label="Edit description"
                                    kind="blank"
                                    size="small"
                                    iconOnly
                                    leadingIcon={Icon.Edit}
                                    onPress={() => setEditing(true)}
                                />
                            </RevealableToolbarItem>
                        </RevealableToolbar>
                    )}
                </RevealableToolbarRoot>
            </div>
            {editing ? (
                <ChangeRequestDescriptionField
                    ref={editorRef}
                    changeRequest={changeRequest}
                    onSaved={() => setEditing(false)}
                    onCancel={() => setEditing(false)}
                    alwaysShowSubmitButton
                />
            ) : isDocumentEmpty(initialDescription.document) ? (
                <div className="text-muted text-ui-small">
                    No description yet —{' '}
                    <Link kind="inherit" onPress={() => setEditing(true)}>
                        Add description
                    </Link>
                </div>
            ) : (
                <BasicEditor
                    readOnly
                    value={initialDescription}
                    onChange={() => {
                        // noop
                    }}
                    className=""
                />
            )}
        </div>
    );
}
